import React, { memo, useState } from 'react'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import { Button, FileUpload, Toast } from '@ow/comps'
import { useAppEx } from '@vt/hooks'
import { excelImport } from '@vt/apis/lib-ex/v2/translate'

const StyledContent = styled.div``
const Steps = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.75rem;
  ${tw`ml-5`}
  .num {
    border: solid 1px #999;
    ${tw`float-left rounded-full w-5 h-5 text-center mr-2 flex items-center justify-center`}
  }
  .dot {
    width: 4px;
    height: 4px;
    border-radius: 3px;
    ${tw`float-left mr-5`}
  }
`
const Line = styled.div`
  width: 1px;
  height: 32px;
  margin-left: 1.35rem;
`

const UploadUser = function ({
  uppyId,
  templateLink,
  onCancel,
  onParsed,
  onUpload,
  loading,
}) {
  const { appId } = useAppEx()
  const [fileInfo, setFileInfo] = useState(null)

  const upload = () => {
    const formData = new FormData()
    const { data } = fileInfo
    formData.append('file', data)
    if (onUpload) {
      onUpload()
    }
    excelImport(appId, formData)
      .then(onParsed)
      .catch((err) => {
        Toast.error({ title: err.message })
      })
  }

  return (
    <StyledContent className="w-full h-full flex flex-col relative">
      <div
        className="w-full mt-3 pt-3 pb-6 px-4 mb-6 rounded-box"
        style={{
          background: 'var(--ow-bg-comps-color)',
          fontSize: '0.75rem',
        }}
      >
        <b>导入提示</b>
        <div className="mt-2 font-extralight">
          <p>
            <b className="mr-1 font-bold">1.</b>
            请先下载导入模板，按照导入模板的提示，规范填写后进行导入
          </p>
          <p className="mt-1">
            <b className="mr-1">2.</b>
            支持多次导入，以最后一次导入的数据为准，请谨慎操作
          </p>
        </div>
      </div>
      <Steps>
        <div className="dot bg-primary" />
        <div className="text-gray-1 float-left mr-2">
          01.下载模版，批量填写信息
        </div>
        <a className="cursor-pointer text-primary-700" href={templateLink}>
          下载模板
        </a>
      </Steps>
      <Line className="bg-primary" />
      <Steps className="mb-6">
        <div className="dot bg-primary" />
        <div className="text-gray-1">02.上传填写好的表格</div>
      </Steps>
      <FileUpload
        uppyId={uppyId}
        fileInfo={fileInfo}
        updateFileInfo={setFileInfo}
      />
      <div className="w-full flex flex-row items-center mt-10 pl-8">
        <Button onClick={onCancel} className="mr-2" stroke>
          取消
        </Button>
        <Button
          disabled={!fileInfo}
          onClick={upload}
          type="primary"
          loading={loading}
        >
          上传
        </Button>
      </div>
    </StyledContent>
  )
}

export default memo(UploadUser)
